import { render } from "./UserGroupShow.vue?vue&type=template&id=7bf91640"
import script from "./UserGroupShow.vue?vue&type=script&lang=js"
export * from "./UserGroupShow.vue?vue&type=script&lang=js"

import exportComponent from "C:\\docker\\bene_piscinas_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__